import React, { useState } from 'react';
import StepTab from 'components/new_ui/Tabs/StepTab';
import Head from './Head';
import Methods from './Methods';
import Footer from './Footer';

export default function Index() {
  const [method, setMethod] = useState(null);

  const createMethodChange = (value) => {
    setMethod(value);
  };

  return (
    <>
      <StepTab total={3} current={1} />

      <div className="content">
        <Head />

        <Methods method={method} onChoose={createMethodChange} />

        <Footer method={method} />
      </div>
    </>
  );
}
